module.exports = __webpack_public_path__ + "assets/img/kv-33ee41ce.jpg";